<template>
  <b-card-text>
    <b-card title="Lista Certyfikatów" class="title-inline">
      <b-card-text>
        <h5 class="my-2 font-weight-bold info-text">Kliknij i pobierz kurs</h5>
      </b-card-text>
      <b-row class="mb-3">
        <b-col lg="12">
          <b-button
            class="btn-outline-white"
            variant="outline-light"
            @click="$emit('showCourse')"
          >
            <span
              class="font-weight-bold info-text"
              v-text="'< Powrót do Kursu'"
            ></span>
          </b-button>
        </b-col>

        <b-col lg="12" class="mr-1 py-2 text-center">
          Wybierz swoje dane z listy:
          <b-row class="justify-content-md-center">
            <b-col lg="auto" class="mr-1 py-2">
              <b-form-select
                class="wd-lg-400"
                v-model="participantSelect"
                :options="participantOptions"
                placeholder="Lista"
              ></b-form-select>
            </b-col>

            <b-col lg="auto" class="mr-1 py-2">
              <b-button
                v-if="!loading"
                class="btn btn-accept-color text-white"
                variant="outline-success"
                @click="onPrintCertificate(participantSelect)"
                :disabled="participantSelect === null"
              >
                Pobierz certyfikat
              </b-button>
              <b-button
                v-else
                class="btn-accept-color"
                variant="outline-success"
                disabled
              >
                <b-spinner small></b-spinner>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
  </b-card-text>
</template>

<script>
export default {
  name: 'CourseCertificateList',
  data() {
    return {
      loading: false,
      participantSelect: null,
    };
  },
  props: {
    styles: {},
    participantWithPass: {},
  },
  created() {},
  computed: {
    participantOptions() {
      let options = [{ value: null, text: 'Lista' }];
      this.participantWithPass.forEach((row) => {
        options.push({
          value: row.participant_name,
          text: row.participant_name,
        });
      });
      return options;
    },
  },
  methods: {
    onPrintCertificate(participantName) {
      window.open(
        '/api/course-exam/print-certificate/' + participantName,
        '_blank'
      );
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
::v-deep {
}
</style>
